import { HttpInterceptorFn } from '@angular/common/http';
import { RecaptchaConfigService, RecaptchaService } from '@core/services';
import { inject } from '@angular/core';
import { AppMethods } from '@core/enums';

export const headersInterceptor: HttpInterceptorFn = (request, next) => {
  const captchaConfig = inject(RecaptchaConfigService);
  const recaptchaService = inject(RecaptchaService);

  const method = request.method;
  let recaptchaHeader = null;

  if (captchaConfig?.recaptchaEnabled() && method === AppMethods.POST) {
    const recaptchaToken = recaptchaService.recaptchaToken();
    recaptchaHeader = { 'X-Recaptcha-Token': `${recaptchaToken}` };
  }

  const headersRequest = request.clone({
    setHeaders: {
      ...recaptchaHeader,
    },
  });

  return next(headersRequest);
};
